import { on } from 'delegated-events'

export default {
  init: () => {
    document.querySelectorAll('a[href*="mailing-list"]').forEach((anchor) => {
      anchor.href = '/_modal/mailinglist'
      anchor.setAttribute('data-modal', 'content')
    })

    on('mailinglistmodal:open', 'html', (e) => {
      const modalEl = e.detail.modalEl
      const modalMailchimpHolder = modalEl.querySelector('.form-holder')
      const footerMailchimpEmbed = document.querySelector('.site-footer .mailchimp-embed')

      if (footerMailchimpEmbed) {
        modalMailchimpHolder.append(footerMailchimpEmbed)
      }
    })

    on('mailinglistmodal:close', 'html', (e) => {
      const modalEl = e.detail.modalEl
      const modalMailchimpEmbed = modalEl.querySelector('.mailchimp-embed')
      const footerMailchimpHolder = document.querySelector('.footer-mailchimp-form')

      if (modalMailchimpEmbed) {
        footerMailchimpHolder.append(modalMailchimpEmbed)
      }
    })

    const mailchimpSuccess = document.getElementById('mce-success-response')

    if (mailchimpSuccess) {
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function () {
          if (mailchimpSuccess.innerHTML === "You're already subscribed, your profile has been updated. Thank you!") {
            mailchimpSuccess.innerHTML = "You're successfully subscribed."
          }
        })
      })

      const config = { attributes: true, childList: true, characterData: true }

      observer.observe(mailchimpSuccess, config)
    }
  },
}
